// extracted by mini-css-extract-plugin
export var typingIndicator = "_rf-0";